<template>
    <ul class="tuijielist synced-recommend-list" v-if="list.length">
        <li v-for="c in list" :key="c.uuid" class="prediction-card">
            <div class="fxlab fxmy" v-if="c.mycommend">我的推荐</div>
            <div class="fxlab fxcm" v-if="c.isconsume">已订阅</div>
            <div class="prediction-expert-top">
                <router-link class="expert-id" :to="'/member/'+c.user.id">
                    <img :src="c.user.portrait || defimg" @error="$event.target.src=defimg"/><span><b class="expert-name"><strong>{{expertName(c)}}</strong><i>认证专家</i></b><em>经验丰富</em></span>
                </router-link>
                <div class="expert-top-metrics"><span><b>{{c.user.winrate || 0}}%</b>7天命中率</span><span class="publish-status"><small>本场状态</small><b>{{statusText(c)}}</b></span></div>
            </div>
            <div class="prediction-league"><span :style="{borderColor:c.color || '#00d7ff'}">{{c.match_type}}</span><time>{{c.time}}</time><b class="prediction-market">{{c.dxq?'大小盘':'让球'}}：<em>{{c.pankou || '-'}}</em></b></div>
            <router-link class="prediction-main" :to="'/recommend/'+c.uuid">
                <div class="team-side home-team"><team-badge :name="c.shangpan" :size="38"/><b>{{c.shangpan}}</b></div>
                <div class="match-center"><small class="match-handicap">让球 {{c.pankou || '-'}}</small><em v-if="c.bifen">{{c.bifen}}</em><em v-else>VS</em><small v-if="hasSettledResult(c)">完场比分</small><small v-else-if="c.bifen">实时赛况</small></div>
                <div class="team-side away-team"><team-badge :name="c.xiapan" :size="38"/><b>{{c.xiapan}}</b></div>
            </router-link>
            <div class="prediction-research">
                <p class="expert-profile-row"><b>专家档案</b><span>{{c.user.intro || '认证赛事研究专家，专注球队状态、阵容变化与比赛数据的综合研判。'}}</span></p>
            </div>
            <div class="prediction-metrics">
                <span><b>{{c.roi || 0}}%</b>推荐回报率</span>
                <span><b>{{c.stability || 0}}%</b>稳定性</span>
                <span><b>{{c.hot_sales || 0}}</b>热销场次</span>
                <span><b>{{c.user.fans_count || 0}}</b>关注人数</span>
            </div>
            <div class="prediction-footer">
                <span class="direction"><b>推荐方向</b>{{c.commend || (c.showtype==2?'订阅后查看':'待公开')}}</span>
                <span class="publish-time">{{c.create}}发布</span>
                <router-link v-if="hasSettledResult(c)" :class="['result-entry', resultClass(c)]" :to="'/recommend/'+c.uuid"><small>赛果</small><strong>{{c.result}}</strong><em>查看分析 →</em></router-link>
                <router-link v-else-if="c.showtype == 1" class="dai" :to="'/recommend/'+c.uuid">待公开 →</router-link>
                <router-link v-else-if="c.showtype == 2" class="kck" :to="'/recommend/'+c.uuid"><em>{{c.gold}}</em> 球币查看 →</router-link>
                <router-link v-else class="gk" :to="'/recommend/'+c.uuid">查看完整分析 →</router-link>
            </div>
        </li>
    </ul>
</template>

<script>
import defPortrait from '../../assets/images/default-analyst-v3.jpg'
import TeamBadge from './team_badge'
export default {
    name: 'RecommendMini',
    components: {TeamBadge},
    props: ['list', 'type'],
    data(){ return {defimg: defPortrait} },
    methods: {
        expertName(c){
            const user=c&&c.user?c.user:{}
            return user.name||user.nick||user.username||'认证专家'
        },
        hasSettledResult(c){
            return Number(c && c.result_id) > 1 && !!(c && c.result)
        },
        resultClass(c){
            if(c.result === '红') return 'result-red'
            if(c.result === '黑') return 'result-black'
            if(c.result === '和') return 'result-draw'
            return 'result-neutral'
        },
        statusText(c){
            if(this.hasSettledResult(c)) return '已完场'
            if(Number(c && c.showtype) === 2) return '待公开'
            return '已发布'
        }
    }
}
</script>

<style scoped></style>
